'use client'

import { ScanLine, ArrowDownRight } from 'lucide-react'
import { useDocumentExample } from '../hooks/use-landing'
import s from '../styles/landing.module.css'

export function DocumentExample() {
  const { selected, setSelected, example } = useDocumentExample()
  return <div className={s.documentExample}>
    <div className={s.exampleIntro}>
      <ScanLine size={30} strokeWidth={1.2} aria-hidden="true" />
      <h3>Belgedeki bilgi,<br />çalışma alanınızda.</h3>
      <p>Fişleri ve Z raporlarını yükleyin. Yapay zekânın okuduğu alanları gözden geçirin, ardından kaydedin.</p>
      <div className={s.exampleToggle} role="group" aria-label="Örnek belge türü">
        <button type="button" aria-pressed={selected === 'receipt'} onClick={() => setSelected('receipt')}>Masraf fişi</button>
        <button type="button" aria-pressed={selected === 'zreport'} onClick={() => setSelected('zreport')}>Z raporu</button>
      </div>
    </div>
    <div className={s.document} aria-live="polite">
      <div className={s.documentHeading}><h4>{example.title}</h4><span>Örnek belge</span></div>
      <dl>{example.fields.map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
      <p className={s.documentNote}><ArrowDownRight size={19} aria-hidden="true" />{example.note}</p>
      <span className={s.reviewNote}>Son kontrol ve kayıt kararı sizde.</span>
    </div>
  </div>
}
